import {
  Box,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";

export default function Forbidden() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: "fixed",
        inset: 0,
        width: "100%",
        height: "100dvh",
        boxSizing: "border-box",
        zIndex: 9999,
        overflow: "hidden",
        p: { xs: 1.5, sm: 2, md: 2.5 },
        background: "linear-gradient(135deg, #f0f4f8 0%, #e8eef5 100%)",
      }}
    >
      <Box
        sx={{
          height: "100%",
          maxWidth: 1800,
          mx: "auto",
          display: "flex",
          flexDirection: "column",
          gap: 2,
          minHeight: 0,
        }}
      >
        {/* Gradient header */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5, md: 3 },
            borderRadius: 4,
            color: "#fff",
            background:
              "linear-gradient(115deg, #192b3d 0%, #247b78 58%, #1c4058 100%)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
            flexWrap: "wrap",
            flexShrink: 0,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: { xs: 24, sm: 32, md: 36 },
                fontWeight: 800,
                letterSpacing: "-1px",
              }}
            >
              Access Forbidden
            </Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: { xs: 13, sm: 15 },
                color: "#e2edf3",
                lineHeight: 1.5,
              }}
            >
              You don't have permission to access this page.
            </Typography>
          </Box>
        </Paper>

        {/* Main content */}
        <Paper
          elevation={0}
          sx={{
            flex: 1,
            minHeight: 0,
            p: { xs: 1.5, sm: 2.5, md: 3 },
            borderRadius: 4,
            border: "1px solid #e1e8f0",
            backgroundColor: "#fff",
            boxShadow: "0 8px 28px rgba(20, 45, 80, 0.05)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: 56, sm: 64 },
              height: { xs: 56, sm: 64 },
              mb: 1.5,
              borderRadius: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#1769aa",
              backgroundColor: "#eaf4ff",
              border: "1px solid #d5e8fb",
              flexShrink: 0,
            }}
          >
            <BlockOutlinedIcon sx={{ fontSize: { xs: 30, sm: 36 } }} />
          </Box>

          <Typography
            sx={{
              fontSize: { xs: 56, sm: 72, md: 84 },
              fontWeight: 800,
              lineHeight: 1,
              letterSpacing: "-4px",
              color: "#142b4a",
            }}
          >
            403
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: { xs: 19, sm: 24 },
              fontWeight: 800,
              color: "#172b4d",
            }}
          >
            Permission required
          </Typography>

          <Typography
            sx={{
              mt: 1,
              maxWidth: 520,
              fontSize: { xs: 13, sm: 14 },
              lineHeight: 1.6,
              color: "#64748b",
            }}
          >
            Your account may not have the required role or access rights for
            this resource. If you believe this is a mistake, please contact
            your administrator.
          </Typography>

          {/* Information panel */}
          <Box
            sx={{
              mt: 2,
              width: "100%",
              maxWidth: 600,
              boxSizing: "border-box",
              p: { xs: 1.5, sm: 2 },
              display: "flex",
              alignItems: "flex-start",
              gap: 1.5,
              textAlign: "left",
              borderRadius: 3,
              border: "1px solid #dbeafe",
              backgroundColor: "#f4f8ff",
              flexShrink: 0,
            }}
          >
            <BlockOutlinedIcon
              sx={{ color: "#2563eb", mt: 0.2, fontSize: 20 }}
            />

            <Box>
              <Typography
                sx={{ fontSize: 13, fontWeight: 700, color: "#1e3a5f" }}
              >
                Access restricted
              </Typography>

              <Typography
                sx={{
                  mt: 0.3,
                  fontSize: 12,
                  lineHeight: 1.6,
                  color: "#64748b",
                }}
              >
                This page is protected by TrackCoreData access controls.
                Return to the previous page or ask your administrator to
                review your permissions.
              </Typography>
            </Box>
          </Box>

          <Button
            variant="contained"
            startIcon={<ArrowBackRoundedIcon />}
            onClick={() => navigate(-1)}
            sx={{
              mt: 2,
              px: 3.5,
              py: 1,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 700,
              backgroundColor: "#087ea4",
              boxShadow: "none",
              flexShrink: 0,
              "&:hover": {
                backgroundColor: "#066786",
                boxShadow: "none",
              },
            }}
          >
            Go Back
          </Button>

          <Typography
            sx={{ mt: 1.5, fontSize: 11, color: "#94a3b8" }}
          >
            TrackCoreData · Access Control
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}
